export default __webpack_public_path__ + "static/media/10 raw.543e669a.mp3";